import ICONS from "../../../assets/Icons";
import "./index.css";

const BalanceLoader = ({ loader, setAccId, type, ownerDetails }) => {
  if (!loader) {
    setTimeout(() => {
      setAccId("");
    }, 1000);
  }

  return (
    <div>
      {loader ? (
        <img
          src={ICONS?.LOADER_GIF}
          className="loader-icon"
          style={{
            width:
              type === "internalTxn"
                ? "9.61px"
                : type === "createTxn"
                  ? "25px"
                  : ownerDetails === "BalanceownerDetails"
                    ? "15px"
                    : type === "homedashboard"
                      ? "var(--icon-sm)"
                      : null,
            height:
              type === "internalTxn"
                ? "9.61px"
                : type === "createTxn"
                  ? "25px"
                  : ownerDetails === "BalanceownerDetails"
                    ? "15px"
                    : type === "owner-dsb"
                      ? "18px"
                      : type === "homedashboard"
                        ? "var(--icon-md)"
                        : null,
          }}
          alt="loader"
        />
      ) : (
        <img
          src={ICONS?.SELECT_GREEN}
          className="checkmark-icon"
          style={{
            marginLeft:
              type === "internalTxn"
                ? "0px"
                : type === "createTxn"
                  ? "0px"
                  : ownerDetails === "BalanceownerDetails"
                    ? "0px"
                    : "4px",
            width:
              type === "internalTxn"
                ? "9.61px"
                : type === "createTxn"
                  ? "15px"
                  : ownerDetails === "BalanceownerDetails"
                    ? "15px"
                    : type === "homedashboard"
                      ? "var(--icon-sm)"
                      : "15px",
            height:
              type === "internalTxn"
                ? "9.61px"
                : type === "createTxn"
                  ? "15px"
                  : ownerDetails === "BalanceownerDetails"
                    ? "15px"
                    : type === "homedashboard"
                      ? "var(--icon-md)"
                      : "15px",
          }}
          alt="checkmark"
        />
      )}
    </div>
  );
};

export default BalanceLoader;
